import { render, staticRenderFns } from "./campus-update-application-status-modal.vue?vue&type=template&id=38ab3db9&scoped=true"
import script from "./campus-update-application-status-modal.vue?vue&type=script&lang=js"
export * from "./campus-update-application-status-modal.vue?vue&type=script&lang=js"
import style0 from "./campus-update-application-status-modal.vue?vue&type=style&index=0&id=38ab3db9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab3db9",
  null
  
)

export default component.exports